import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type WebsiteDashboardRoutes = {
    website: Route
    manage: Route
    settings: Route
    theme: Route
    homepage: Route
    banners: Route
    seo: Route
    inquiries: Route
    reviews: Route
    businessHours: Route
}

export const websiteDashboardRoutes: WebsiteDashboardRoutes = {
    website: {
        path: 'dashboard/website',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./page-website/page-website.component').then(
                (m) => m.PageWebsiteComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    manage: {
        path: 'dashboard/website/manage',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./page-website/page-website.component').then(
                (m) => m.PageWebsiteComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    settings: {
        path: 'dashboard/website/settings',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./website-settings/website-settings.component').then(
                (m) => m.WebsiteSettingsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    theme: {
        path: 'dashboard/website/theme',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./website-theme/website-theme.component').then(
                (m) => m.WebsiteThemeComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    homepage: {
        path: 'dashboard/website/homepage',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./website-homepage/website-homepage.component').then(
                (m) => m.WebsiteHomepageComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    banners: {
        path: 'dashboard/website/banners',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./website-banners/website-banners.component').then(
                (m) => m.WebsiteBannersComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    seo: {
        path: 'dashboard/website/seo',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./website-seo/website-seo.component').then(
                (m) => m.WebsiteSeoComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    inquiries: {
        path: 'dashboard/website/inquiries',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./website-inquiries/website-inquiries.component').then(
                (m) => m.WebsiteInquiriesComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    reviews: {
        path: 'dashboard/website/reviews',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.shop.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./website-reviews/website-reviews.component').then(
                (m) => m.WebsiteReviewsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    businessHours: {
        path: 'dashboard/website/business-hours',
        redirectTo: '/dashboard/settings/business-hours',
        pathMatch: 'full',
    },
}
